import { INDIA_PATHS, INDIA_VIEWBOX } from "./indiaPaths";

const CITIES = [
  { name: "Chandigarh", x: 180.4, y: 144.7 },
  { name: "Delhi NCR", x: 189.4, y: 193.7, hub: true },
  { name: "Jaipur", x: 159.7, y: 232.9, anchor: "end" },
  { name: "Lucknow", x: 267.6, y: 234.3 },
  { name: "Guwahati", x: 493.4, y: 250.7, anchor: "end" },
  { name: "Ahmedabad", x: 92.3, y: 322.7, anchor: "end" },
  { name: "Indore", x: 161.1, y: 329.6 },
  { name: "Kolkata", x: 422.7, y: 333.1 },
  { name: "Bhubaneswar", x: 369.5, y: 385.5, anchor: "end" },
  { name: "Mumbai", x: 98.8, y: 413.6, anchor: "end" },
  { name: "Pune", x: 119.3, y: 426.6 },
  { name: "Hyderabad", x: 216.2, y: 452.9 },
  { name: "Goa", x: 118.6, y: 496.5, anchor: "end" },
  { name: "Chennai", x: 253.4, y: 552.1 },
  { name: "Bengaluru", x: 197.3, y: 554.7, anchor: "end" },
  { name: "Kochi", x: 169.7, y: 624.8, anchor: "end" },
];

const HUB = CITIES.find((c) => c.hub);

export default function IndiaMap() {
  return (
    <svg
      viewBox={INDIA_VIEWBOX}
      className="h-auto w-full"
      role="img"
      aria-label="Map of India marking the sixteen cities where TSCM Services operates"
      data-testid="coverage-map"
    >
      {[80, 180, 280, 380, 480].map((x) => (
        <line key={x} x1={x} y1="0" x2={x} y2="696" stroke="var(--ink)" strokeOpacity="0.05" strokeDasharray="2 6" />
      ))}
      {[100, 220, 340, 460, 580].map((y) => (
        <line key={y} x1="0" y1={y} x2="612" y2={y} stroke="var(--ink)" strokeOpacity="0.05" strokeDasharray="2 6" />
      ))}

      {INDIA_PATHS.map((d, i) => (
        <path key={`glow-${i}`} d={d} fill="none" stroke="var(--violet)" strokeOpacity="0.12" strokeWidth="4" strokeLinejoin="round" />
      ))}
      {INDIA_PATHS.map((d, i) => (
        <path
          key={i}
          d={d}
          fill="var(--wash)"
          stroke="var(--violet)"
          strokeOpacity="0.38"
          strokeWidth="0.9"
          strokeLinejoin="round"
        />
      ))}

      {CITIES.filter((c) => !c.hub).map(({ name, x, y }) => (
        <line
          key={`link-${name}`}
          x1={HUB.x}
          y1={HUB.y}
          x2={x}
          y2={y}
          stroke="var(--violet)"
          strokeOpacity="0.14"
          strokeWidth="1"
          strokeDasharray="1 5"
        />
      ))}

      {CITIES.map(({ name, x, y, anchor, hub }, i) => (
        <g key={name}>
          <circle
            cx={x}
            cy={y}
            r={hub ? 13 : 10}
            fill="var(--violet)"
            fillOpacity="0.18"
            className="marker-pulse"
            style={{ animationDelay: `${i * 0.3}s` }}
          />
          <circle cx={x} cy={y} r={hub ? 4.5 : 3.4} fill="var(--violet)" stroke="var(--bg)" strokeWidth="1.2" />
          <text
            x={anchor === "end" ? x - 12 : x + 12}
            y={y + 4}
            textAnchor={anchor || "start"}
            fontSize="11.5"
            fontFamily="IBM Plex Mono, monospace"
            letterSpacing="1"
            fill="var(--ink)"
            fillOpacity="0.8"
          >
            {name.toUpperCase()}
          </text>
        </g>
      ))}
    </svg>
  );
}
